<template>
    <div class="pickRole">
        <div class="pickRole__container">
            <img class="pickRole__logo" src="@\assets\logo-fundacion-forge.png" alt="">
            <h2 class="pickRole__title" >{{$t('global.TITLE')}}</h2>
            <h3 class="pickRole__subtitle" >{{ $t('pickrole.INSTRUCTION') }}</h3>
            <div class="pickRole__roles">
                <div class="pickRole__role" v-for="(role, index) in userData.profiles" :key="index" @click.stop="pickRole(role.role)">
                    <i class="material-icons-outlined">
                        {{ 
                            role.role === 'TUTOR' ? 'supervised_user_circle' : 'menu_book'
                        }}
                    </i>
                    {{$t(`role.${role.role}`)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import persistentData from '@/plugins/persistentData';
import { computed, ref } from '@vue/reactivity';
import {  useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default{
    setup(){
        const userData = persistentData.get('user', true);
        const router = useRouter()
        const store = useStore()
        const redirect = computed(() => store.getters.getRedirectPath);
        const awaitRequest = ref(false);

        async function pickRole(role){
            if(awaitRequest.value) return;
            try{
                awaitRequest.value = true;
                if(userData.role === role){
                    store.dispatch('manageUser_active');
                }
                else {
                    await store.dispatch('manageUser_pickRole', role);
                    await store.dispatch('manageUser_active');
                }
                if(redirect.value && redirect.value != '/login'){
                    router.push(redirect.value);
                } else {
                    router.push('/');
                }
            } catch(error){
                console.log(error);
                store.dispatch('notifications_create', { text: 'Ocurrió un error el seleccionar el perfil. Intente nuevamente.'})
            } finally {
                awaitRequest.value = false;
            }
        }

        return {
            userData,
            pickRole
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/main.scss';
.pickRole{
    width: 100vw;
    min-height: calc(100vh - 56px);
    display: flex;
    align-items: center;
    justify-content: center;
    &__container{
        width: 96%;
        max-width: 520px;
        display: flex;
        flex-direction: column;
        gap: 18px;
        background: #fff;
        padding: 46px 78px 64px 78px;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
    }
    &__logo{
        width: 72px;
        margin: auto;
    }
    &__title{
        color: $black;
        font-weight: 700;
        text-align: center;
        font-size: 22px;
    }
    &__subtitle{
        margin-bottom: 8px;
        color: $black;
        font-weight: 600;
        text-align: center;
        font-size: 16px;
    }
    &__roles{
        @include flex-column;
        gap: 14px;
    }
    &__role{
        position: relative;
        width: 100%;
        padding: 24px 30px;
        border-radius: 10px;
        background-color: $lightgray;
        cursor: pointer;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        color: map-get($dark, 700);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
        &--selected{
            background-color: rgba($color: $lightgreen, $alpha: .5);
            color: $green;
            .done{
                position: absolute;
                right: 30px;
            }
        }
    }
}
</style>